import React from 'react';
import { Box, Heading, Text, UnorderedList, ListItem, OrderedList, Link, Divider } from '@chakra-ui/react';

export const CmpRiflePurchase = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        The Civilian Marksmanship Program (CMP) offers eligible individuals the opportunity to purchase historic military rifles. As a Golden Gun Club member, you can obtain the required documentation through our club to complete your CMP rifle purchase.
      </Text>

      <Divider my={6} />

      <Heading as="h2" size="md" mb={4} color="black">Club CMP Affiliation</Heading>
      <Text mb={4} color="black">
        Golden Gun Club is an official CMP-affiliated organization with the following details:
      </Text>
      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem><strong>CMP Affiliation ID:</strong> #051004</ListItem>
        <ListItem><strong>Registered Name:</strong> Golden Gun Club</ListItem>
        <ListItem><strong>Status:</strong> Current (renewed annually)</ListItem>
        <ListItem><strong>Registration Type:</strong> Senior Club only (no Junior or Collegiate registration)</ListItem>
      </UnorderedList>
      <Text mb={4} color="black">
        This affiliation allows Golden Gun Club members to obtain the required proof of membership documentation for CMP rifle purchases.
      </Text>

      <Divider my={6} />

      <Heading as="h2" size="md" mb={4} color="black">Documentation Requirements</Heading>
      <Text mb={4} color="black">
        To purchase a rifle through the CMP, you must provide two forms of documentation:
      </Text>

      <Divider my={6} />

      <Heading as="h3" size="sm" mb={3} color="black">1. Proof of Membership</Heading>
      <Text mb={4} color="black">
        As a Golden Gun Club member, you are eligible to receive a <strong>Proof of Membership</strong> form. This document verifies your membership in a CMP-affiliated organization.
      </Text>
      <Text mb={4} color="black">
        <Link href="/matches-competition/cmp-highpower-service-rifle/rifle-purchase/membership-form" color="blue.500">
          <strong>Get Your Proof of Membership Form →</strong>
        </Link>
      </Text>

      <Divider my={6} />

      <Heading as="h3" size="sm" mb={3} color="black">2. Proof of Marksmanship</Heading>
      <Text mb={4} color="black">
        The CMP requires documentation that demonstrates your marksmanship competency. This can be satisfied by:
      </Text>
      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem><strong>Participating in a Golden Gun Club Service Rifle Match</strong></ListItem>
        <ListItem><strong>Having the Match Director sign your Proof of Marksmanship form</strong></ListItem>
        <ListItem><strong>Copy of Concealed Carry Permit</strong></ListItem>
        <ListItem><strong>Copy of Hunter's Safety License</strong> (provided Hunter Safety Course required live-fire)</ListItem>
      </UnorderedList>

      <Text mb={3} color="black"><strong>Steps to Complete:</strong></Text>
      <OrderedList spacing={2} ml={6} mb={4}>
        <ListItem>Download the <Link href="https://thecmp.org/wp-content/uploads/marksmanship.pdf" color="blue.500" isExternal>CMP Proof of Marksmanship form</Link></ListItem>
        <ListItem>Attend one of our monthly Service Rifle matches (held April through October on the Central Range, November through March on the East Range as Rimfire matches)</ListItem>
        <ListItem>After participating in the match, have our Match Director sign your form</ListItem>
        <ListItem>Submit the completed form with your CMP rifle purchase application</ListItem>
      </OrderedList>

      <Divider my={6} />

      <Heading as="h2" size="md" mb={4} color="black">Contact Information</Heading>
      <Text mb={4} color="black">
        For questions about CMP rifle purchases or our Service Rifle matches, contact:
      </Text>
      <Text mb={4} color="black">
        <strong>Matt Anthony</strong> - Match Director<br />
        Email: <Link href="mailto:competitions@goldengunclub.us" color="blue.500">competitions@goldengunclub.us</Link><br />
        Phone: 720-775-5243
      </Text>

      <Divider my={6} />

      <Heading as="h2" size="md" mb={4} color="black">Additional Resources</Heading>
      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem><Link href="https://thecmp.org/" color="blue.500" isExternal>CMP Official Website</Link></ListItem>
        <ListItem><Link href="https://thecmp.org/cmp_sales/" color="blue.500" isExternal>CMP Rifle Sales Information</Link></ListItem>
        <ListItem><Link href="/matches-competition/cmp-highpower-service-rifle" color="blue.500">Golden Gun Club Service Rifle Match Information</Link></ListItem>
      </UnorderedList>

      <Divider my={6} />

      <Text fontSize="sm" fontStyle="italic" color="gray.600">
        Please note: Both forms must be completed and submitted along with other CMP requirements to be eligible for rifle purchase. Visit the official CMP website for complete eligibility requirements and current rifle availability.
      </Text>
    </Box>
  );
};